<template>
  <a-modal
      v-model:visible="show"
      :confirmLoading="isLoading"
      :title="modalTitle"
      :width="800"
      :zIndex="1001"
      @cancel="cancel"
      @ok="addSave"
  >
    <a-form
        ref="formRef"
        :label-col="{ span: 6 }"
        :model="addForm"
        :rules="rules"
        hideRequiredMark
        labelAlign="left"
    >
      <div class="add-box">
        <div class="add-lef">
          <a-form-item label="类型：" name="type">
            <a-select
                v-model:value="addForm.type"
                placeholder="类型"
                style="width: 100%"
            >
              <a-select-option
                  v-for="(item, index) in searchList.tasktype.list"
                  :key="index"
                  :value="item.id"
              >{{ item.name }}
              </a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item label="房间：">
            <a-select
                v-model:value="addForm.hid"
                :allowClear="modalTitle == '创建任务'"
                :filter-option="false"
                placeholder="请选择房间（可选）"
                show-search
                style="width: 100%"
                @change="changeRoom"
                @focus="searchRoom"
                @search="roomFilter"
            >
              <a-select-option
                  v-for="(item, index) in roomList"
                  :key="index"
                  :value="item.id"
              >{{ item.name }}
              </a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item label="日期：" name="date">
            <a-date-picker
                v-model:value="addForm.date"
                style="width: 100%"
                valueFormat="YYYY-MM-DD"
            />
          </a-form-item>
          <a-form-item label="时间：" name="time">
            <a-time-picker
                v-model:value="addForm.time"
                format="HH:mm"
                style="width: 100%"
                valueFormat="HH:mm"
            />
          </a-form-item>
          <a-form-item label="被分配人：">
            <a-select
                v-model:value="addForm.mid"
                :allowClear="modalTitle == '创建任务'"
                :filterOption="tasknumberFilter"
                placeholder="被分配人(可选)"
                show-search
                @focus="getMemberList"
            >
              <a-select-option
                  v-for="(item, index) in memberList"
                  :key="index"
                  :value="item.id"
              >{{ item.name }}
              </a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item
              v-if="addForm.type == 1"
              label="保洁等级："
              name="clean_level"
          >
            <a-select
                v-model:value="addForm.clean_level"
                placeholder="请选择保洁等级"
                @change="changeCleanlevel"
            >
              <a-select-option :value="1">简单</a-select-option>
              <a-select-option :value="2">标准</a-select-option>
              <a-select-option :value="3">高级</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="费用：" name="amount">
            <a-input-number
                v-model:value="addForm.amount"
                placeholder="请输入费用"
                style="width: 100%"
            >
            </a-input-number>
          </a-form-item>
          <div
              v-if="addForm.amount && modalTitle == '创建任务'"
              class="checkbox"
          >
            <a-checkbox v-model:checked="addForm.check">计入收支</a-checkbox>
          </div>
          <a-form-item v-if="addForm.check" label="支付方式：" name="pay_id">
            <a-select
                v-model:value="addForm.pay_id"
                placeholder="请选择支付方式"
            >
              <a-select-option
                  v-for="(item, index) in searchList.paytype.list"
                  :key="index"
                  :value="item.id"
              >{{ item.name }}
              </a-select-option
              >
            </a-select>
          </a-form-item>
        </div>
        <div class="add-rig">
          <a-form-item label="描述：" name="remark">
            <a-textarea
                v-model:value="addForm.remark"
                :rows="4"
                placeholder="请输入描述（可选）"
            />
          </a-form-item>
          <a-form-item label="附件：">
            <a-upload
                v-model:file-list="imageList"
                :action="action"
                :data="formData"
                :headers="header"
                :maxCount="5"
                :remove="handleRemoveImage"
                :showUploadList="{ showPreviewIcon: false }"
                list-type="picture-card"
                name="image"
                @change="handleChangeImage"
            >
              <div v-if="imageList.length < 5">
                <plus-outlined/>
                <div style="margin-top: 8px">点击上传</div>
              </div>
            </a-upload>
          </a-form-item>
        </div>
      </div>
    </a-form>
  </a-modal>
</template>

<script>
import {defineComponent, onMounted, reactive, toRefs, watch} from "vue";
import {getHouseList, getSearchList, taskAdd, taskCleanFeeList, taskEdit, taskMemberList,} from "@/api/api";
import {message} from "ant-design-vue";
import {verifyPrice} from "@/common/validator";
import {PlusOutlined} from "@ant-design/icons-vue";
import dayjs from "dayjs";
import { baseRequestUrl } from "../../../../config.js";

export default defineComponent({
  components: {
    PlusOutlined,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    title: {
      default: "创建任务",
    },
    hid: {
      default: null,
    },
    date: {
      default: dayjs().format("YYYY-MM-DD"),
    },
    form: {
      default: null,
    },
  },
  emits: ["update:visible", "confirm"],
  setup(props, {emit}) {
    // 弹窗
    const modal = reactive({
      modalTitle: props.title,
      show: false,
      changeCleanlevel() {
        if (modal.addForm.clean_level == 1) {
          modal.addForm.amount = modal.price.clean_easy
              ? modal.price.clean_easy
              : modal.addForm.amount;
        } else if (modal.addForm.clean_level == 2) {
          modal.addForm.amount = modal.price.clean_norm
              ? modal.price.clean_norm
              : modal.addForm.amount;
        } else if (modal.addForm.clean_level == 3) {
          modal.addForm.amount = modal.price.clean_expert
              ? modal.price.clean_expert
              : modal.addForm.amount;
        }
      },
      memberList: [],
      getMemberList() {
        taskMemberList({
          status: 1,
        }).then((res) => {
          modal.memberList = res.data.list;
        });
      },
      tasknumberFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
      changeRoom() {
        if (modal.addForm.type == 1) {
          taskMemberList({
            hid: modal.addForm.hid,
            status: 1,
          }).then((res) => {
            modal.addForm.mid = res.data.list[0].id;
          });
          taskCleanFeeList({
            hids: modal.addForm.hid,
          }).then((res) => {
            modal.price.clean_norm = res.data.list[0].clean_norm;
            modal.price.clean_expert = res.data.list[0].clean_expert;
            modal.price.clean_easy = res.data.list[0].clean_easy;
            switch (modal.addForm.clean_level) {
              case 1:
                modal.addForm.amount = modal.price.clean_easy;
                break;
              case 2:
                modal.addForm.amount = modal.price.clean_norm;
                break;
              case 3:
                modal.addForm.amount = modal.price.clean_expert;
                break;
            }
          });
        }
      },
      formRef: "", //表单验证
      price: {
        clean_norm: "",
        clean_expert: "",
        clean_easy: "",
      },
      addForm: {
        type: 1,
        date: props.date,
        time: "",
        mid: [],
        hid: [],
        amount: "",
        pay_id: [],
        clean_level: 1,
        remark: "",
        check: false,
        url_arr: [],
      },
      imageList: [],
      rules: {
        type: [
          {
            required: true,
            message: "请输入房型名称",
            trigger: "blur",
            type: "number",
          },
        ],
        date: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        time: [
          {
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        clean_level: [
          {
            required: true,
            message: "请选择保洁等级",
            trigger: "change",
            type: "number",
          },
        ],
        amount: [
          {
            required: true,
            validator: verifyPrice,
            trigger: "blur",
          },
        ],
        remark: [
          {
            required: false,
            message: "请输入描述",
            trigger: "blur",
          },
        ],
        pay_id: [
          {
            required: true,
            message: "请选择支付方式",
            trigger: "change",
            type: "number",
          },
        ],
      },
      // 取消
      cancel() {
        emit("cancel");
      },
      // 保存
      isLoading: false,
      addSave() {
        if (modal.modalTitle == "创建任务") {
          modal.formRef.validate().then(() => {
            modal.isLoading = true;
            let obj = JSON.parse(JSON.stringify(modal.addForm));
            if (obj.check) {
              obj.pay_id = typeof obj.pay_id === "object" ? "" : obj.pay_id;
            } else {
              obj.pay_id = "";
            }
            obj.mid =
                typeof obj.mid === "object" && !obj.mid.length
                    ? ""
                    : obj.mid.toString();
            obj.hid =
                typeof obj.hid === "object" && !obj.hid.length
                    ? ""
                    : obj.hid.toString();
            obj.url_arr = obj.url_arr ? JSON.stringify(obj.url_arr) : "";
            taskAdd(obj)
                .then((res) => {
                  message.success(res.msg);
                  modal.isLoading = false;
                  modal.show = false;
                  emit("confirm");
                })
                .catch(() => {
                  modal.isLoading = false;
                });
          });
        } else {
          modal.formRef.validate().then(() => {
            modal.isLoading = true;
            let obj = {};
            obj.task_id = modal.addForm.id;
            obj.type = modal.addForm.type;
            obj.date = modal.addForm.date;
            obj.time = modal.addForm.time;
            obj.amount = modal.addForm.amount;
            obj.clean_level = modal.addForm.clean_level;
            obj.remark = modal.addForm.remark;
            obj.url_arr = modal.addForm.url_arr
                ? JSON.stringify(modal.addForm.url_arr)
                : "";
            if (modal.addForm.check) {
              obj.pay_id =
                  typeof modal.addForm.pay_id === "object"
                      ? ""
                      : modal.addForm.pay_id;
            } else {
              obj.pay_id = "";
            }
            obj.mid =
                typeof modal.addForm.mid === "object" && !obj.mid.length
                    ? ""
                    : modal.addForm.mid.toString();
            obj.hid =
                typeof modal.addForm.hid === "object" && !obj.hid.length
                    ? ""
                    : modal.addForm.hid.toString();
            taskEdit(obj)
                .then((res) => {
                  message.success(res.msg);
                  modal.isLoading = false;
                  modal.show = false;
                  emit("confirm");
                })
                .catch(() => {
                  modal.isLoading = false;
                });
          });
        }
      },
      roomList: [],
      searchRoom() {
        getHouseList({
          start: 0,
          limit: 99,
        }).then((res) => {
          modal.roomList = res.data.list;
        });
      },
      throttle: false,
      throttleInput: "",
      roomFilter(input) {
        modal.throttleInput = input;
        if (modal.throttle) {
          return;
        }
        modal.throttle = true;
        setTimeout(() => {
          getHouseList({
            start: 0,
            limit: 99,
            name: modal.throttleInput,
          }).then((res) => {
            modal.roomList = res.data.list;
            modal.throttle = false;
          });
        }, 1000);
      },
      // 上传
      uploadLoading: false,
      action:
          baseRequestUrl + "/h5/upload/uploadImg" +
          "?info=" +
          JSON.parse(sessionStorage.getItem("landlordInfo")).info,
      header: {
        token: JSON.parse(sessionStorage.getItem("landlordInfo")).token,
        version: "1.0.0",
        source: "1",
      },
      formData: {
        module: "pms",
        type: "logo",
      },
      handleChangeImage(info) {
        if (info.file.status === "uploading") {
          modal.uploadLoading = true;
          return;
        }
        if (info.file.status === "done") {
          modal.addForm.url_arr.push({
            id: 0,
            url: info.file.response.data.url,
            is_del: 0,
          });
          modal.uploadLoading = false;
        }
        if (info.file.status === "error") {
          modal.uploadLoading = false;
          message.error("上传错误");
        }
      },
      handleRemoveImage(e) {
        if (e.response) {
          for (let index in modal.addForm.url_arr) {
            if (modal.addForm.url_arr[index].url == e.response.data.path) {
              modal.addForm.url_arr.splice(index, 1);
            }
          }
        } else {
          for (let item of modal.addForm.url_arr) {
            if (item.url == e.url) {
              item.is_del = 1;
            }
          }
        }
      },
      searchList: {
        deposit: {},
        group: {},
        income: {},
        inout: {},
        paytype: {},
        room: {},
        source: {},
        tag: {},
        taskmember: {},
        taskstatus: {},
        tasktype: {},
      },
      getSearchData() {
        if (!modal.searchList.length) {
          getSearchList().then((res) => {
            modal.searchList = res.data;
          });
        }
      },
    });
    onMounted(() => {
      //   modal.getSearchData();
      //   modal.searchRoom();
      //   if (props.hid) {
      //     modal.addForm.hid = [props.hid];
      //   }
      //   if (props.form) {
      //     modal.addForm = JSON.parse(JSON.stringify(props.form));
      //     modal.imageList = modal.addForm.url_arr.map((item) => {
      //       return { uid: item.id, url: item.url };
      //     });
      //     modal.getMemberList();
      //   }
    });

    watch(
        () => props.visible,
        (newValue) => {
          modal.modalTitle = props.title;
          modal.show = newValue;
          if (newValue) {
            modal.addForm = {
              type: 1,
              date: props.date,
              time: "",
              mid: [],
              hid: [],
              amount: "",
              pay_id: [],
              clean_level: 1,
              remark: "",
              check: false,
              url_arr: [],
            };
            modal.getSearchData();
            modal.searchRoom();
            if (props.hid) {
              modal.addForm.hid = [props.hid];
            }
            if (props.form) {
              modal.addForm = JSON.parse(JSON.stringify(props.form));
              modal.imageList = modal.addForm.url_arr.map((item) => {
                return {uid: item.id, url: item.url};
              });
              modal.getMemberList();
            }
          }
        }
    );

    watch(
        () => modal.show,
        (value) => {
          emit("update:visible", value);
        }
    );

    return {
      ...toRefs(modal),
    };
  },
});
</script>

<style lang="scss" scoped>
.add-box {
  width: 100%;
  display: flex;
  // justify-content: space-between;
  .add-lef {
    flex: 1;
    margin-right: 50px;
  }

  .add-rig {
    flex: 1;
  }
}

.checkbox {
  margin-left: 90px;
  margin-bottom: 24px;
}
</style>
